import { useState, useEffect } from "react"
/*
*
* Funciones de validacion
*
*/
const maxValue = (value, max) => {
  if (value.replace) value = value.replace(" ", "");
  // console.log(value)
  if (Number(value) < Number(max)) return true;
  return false;
};

const minValue = (value, min) => {
  if (value.replace) value = value.replace(" ", "");
  if (Number(value) > Number(min)) return true;
  return false;
};

const nullVerification = (value) => {
  if (value !== "") return true;
  return false;
};

const postal = (value) => {
  value = value.replace(" ", "");
  if (value.length >= 4) return true;
  return false;
};
const CURP = (curp) => {
  var re = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/,
    validado = curp.match(re);

  if (!validado){
    return false;
  }  //Coincide con el formato general?

  //Validar que coincida el dígito verificador
  function digitoVerificador(curp17) {
    //Fuente https://consultas.curp.gob.mx/CurpSP/
    var diccionario = "0123456789ABCDEFGHIJKLMNÑOPQRSTUVWXYZ",
      lngSuma = 0.0,
      lngDigito = 0.0;
    for (var i = 0; i < 17; i++)
      lngSuma = lngSuma + diccionario.indexOf(curp17.charAt(i)) * (18 - i);
    lngDigito = 10 - lngSuma % 10;
    if (lngDigito == 10) return 0;
    return lngDigito;
  }

  if (validado[2] != digitoVerificador(validado[1])) return false;
   

  return true; //Validado
}
const RFC = (value) => {
  value = value.replace(" ", "").toUpperCase();
  if (
    /^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))((-)?([A-Z\d]{3}))$/.test(
      value
    )
  )
    return true;
  return false;
};

const email = (value) => {
  value = value.replace(" ", "");
  if (
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
      value
    )
  )
    return true;
  return false;
};

const number = (value) => {
  value = value.replace(" ", "");
  if (!isNaN(value)) return true;
  return false;
};

const sizeCheck = (size, limit) => {
  if (size === parseInt(limit)) return true;
  return false;
}

/*
 *
 * Crea un objeto/clase por cada field en el form. Contiene su typo, nombre y verificaciones a considerar
 *
 * @param {string} name Nombre del input
 * @param {string} type Typo del input
 * @param {array} constraints Array de strings que declaran las validaciones a realizar. Los siguientes valores y sus significados son:
 *       "null"  : es requerido llenarlo,
 *       ">#"    : es mayor que #,
 *       "<#"    : es menor que #,
 *       "postal": formato de codigo postal
 *       "RFC"   : formato de un RFC
 *       "email" : formato de un email
 *       "number": es un numero
 *
 * Ejemplo let field = FieldFactory("name", "text", ["null", ">3", "<5"]), crea un objeto que maneja el field con nombre "name" de tipo "texto".
 *                                                                        A la hora de verificacion revisara que no este vacio, su valor sea mayor que 3 y menor que 5.
 *
 * @returns {Object} Field Objeto que maneja los fields individuales del form.
 * 
 * para crear mas verificaciones, agregar una funcion extra que regrese false si no pasa la verificacion,agregarla en el comentario de documentacion y agregarlo en el switch. 
 * 
 */

const FieldValidationFactory = (props, checkForm, linkdFieldsReady, form) => {
  let constraints = props.requirements;
  if (!constraints) constraints = [];
  let warning = ""
  let firstReady = !constraints.includes("null")
  const [ready, setready] = useState(firstReady);
  let name = props.name;

  let informDependants = () => {
    if (!props.dependantFields) return;
    props.dependantFields.map(df => {
      form().getField(df).updateReqFields({ name: props.name, status: ready });
    })
  }

  useEffect(() => {
    checkForm();
    informDependants();
  }, [ready]);

  let verify = (value, size) => {
    if (value.hasOwnProperty("warning")) {
      setready(false);
      return {
        flag: false,
        warning: value.warning
      }
    }
    let tempWarning = ""
    let flag = true;
    let notNullFlag = constraints.includes("null")
    // console.log(size);
    // console.log("verify",value)
    constraints.some((item) => {
      let limit = 0;
      let sizeFlag = false;
      let reqFields = [];
      if (item.includes("size")) {
        sizeFlag = true;
        // console.log("sizeflag")
      }
      if (item.includes(">")) {
        limit = item.split(">")[1];
        item = ">";
      } else if (item.includes("<")) {
        limit = item.split("<")[1];
        item = "<";
      } else if (item.includes("=")) {
        limit = item.split("=")[1];
        item = "=";
      }

      if (item.includes("reqFields")) {
        reqFields = item.split("reqFields:")[1].split(",");
        // console.log("reqFields", reqFields)
        item = "reqFields"
      }

      switch (item) {
        case "null":
          if (!nullVerification(value)) {
            tempWarning = "Este campo es requerido"
            flag = false;
          };
          break;
        case "reqFields":
          // console.log(reqFields)
          break;
        case ">":
          if (sizeFlag && !minValue(size.size, limit)) {
            tempWarning = "El número de caracteres mínimo es " + (Number(limit) + 1)
            flag = false;
          }
          if (!sizeFlag && !minValue(value, limit)) {
            tempWarning = "El campo tiene que ser mayor que " + limit
            flag = false;
          };
          break;
        case "<":
          if (!sizeFlag && !maxValue(value, limit)) {
            tempWarning = "El campo tiene que ser menor que " + limit
            flag = false;
          };
          break;
        case "postal":
          if (!postal(value)) {
            tempWarning = "Longitud minima de 4 dígitos"
            flag = false;
          };
          break;
        case "RFC":
          if (!RFC(value)) {
            tempWarning = "Ingrese un RFC válido"
            flag = false;
          };
          break;
        case "CURP":
          if(!CURP(value)){
            tempWarning = "Ingrese un CURP válido"
            flag = false;
          }
          break;
        case "email":
          if (!email(value)) {
            tempWarning = "Ingrese un correo válido"
            flag = false;
          };
          break;
        case "number":
          if (!number(value)) {
            tempWarning = "El valor tiene que ser un numero"
            flag = false;
          };
          break;
        case "=":
          // console.log(size.size);
          if (sizeFlag && !sizeCheck(size.size, limit)) {
            tempWarning = "Debe haber " + limit + " dígitos en el campo"
            flag = false;
          }
          break;
        case "space":
          if(value.length > 0) {
            if([...value][0] === ' ') {
              tempWarning = "El texto contiene mas espacios"
              flag = false;
            } else {
              let arrayWord = [...value];
              for (let i = 0; i < arrayWord.length; i++) {
                if(arrayWord.length === (i + 1)) {
                  break;
                }
                let isSpace = arrayWord[i] === ' ';
                let isNextSpace = arrayWord[i+1] === ' ';
                if(isSpace && isNextSpace) {
                  tempWarning = "El texto contiene mas espacios"
                  flag = false;
                  break;
                }
              }
            }
          }
          break;
        case "ceroFrist": 
        if(value.length > 0) {
          if([...value][0] === '0') {
            tempWarning = "No se permiten ceros al comienzo"
            flag = false;
          } 
        }
          break;
        case "containSapces": {
          if(value.length > 0) {
            let arrayWord = [...value];
            for (let i = 0; i < arrayWord.length; i++) {
              if(arrayWord[i] === " ") {
                tempWarning = "No se permiten espacios"
                flag = false;
                break;
              }
            }
          } 
        }
      }
    });
    warning = tempWarning
    if (!value && !notNullFlag) {
      flag = true;
      warning = '';
    }
    if (size.links) {
      size.links.forEach(field => {
        // console.log(field.getName())
        field.setReady(flag, warning);
      });
    }
    setready(flag);


    return ({ flag, warning })

  };

  return {
    getWarning(value, size) {
      return verify(value, size).warning;
    },
    isReady() {
      return ready;
    },
    setReady(state) {
      setready(state);
      // if(state) {setWarning("")}
    },
    verifyField(value, size) {
      // console.log("verify method",value,size)
      // verify(value, size);
      return verify(value, size).flag;
    },
  };
};

export default FieldValidationFactory;